import { QUERIES_KEYS } from "queries";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { shopApi } from "./shopApi";

export const useHeadingStyles = () => {
  const queryClient = useQueryClient();

  const { isLoading, isFetching, data } = useQuery({
    queryKey: QUERIES_KEYS.HEADING_STYLES(),
    queryFn: () => shopApi.fetchHeadingStyles(),
  });

  const invalidate = () => {
    queryClient.invalidateQueries({
      queryKey: QUERIES_KEYS.HEADING_STYLES(),
    });
  };

  return {
    isLoading,
    isFetching,
    headingStyles: data?.data,
    invalidate,
  };
};
